import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { BackNav } from '@/components/BackNavigation/BackNavigation';
import { useAuth } from '@/lib/auth';
import { Pet } from '../types';
import { PetDetailCard } from '../components/MyPetDetailCard';
import { VerticalTabs } from '@/components/Tab/VerticalTab';
import { PetProfileForm } from '../components/PetProfileForm';
import { PetVaccinationForm } from '../components/PetVaccinationForm';
import { PetInsuranceForm } from '../components/PetInsuranceForm';
import { PetSettings } from '../components/PetSettings';

import { ReactComponent as PawIconGrey } from '@/assets/img/v2/menu-paw-icon.svg';
import { ReactComponent as PawIconSelected } from '@/assets/img/v2/menu-paw-icon-selected.svg';

import { ReactComponent as VaccinationIconGrey } from '@/assets/img/v2/menu-vacc-icon.svg';
import { ReactComponent as VaccinationIconGreySelected } from '@/assets/img/v2/menu-vacc-icon-selected.svg';

import { ReactComponent as InsuranceIconGrey } from '@/assets/img/v2/menu-doc-icon.svg';
import { ReactComponent as InsuranceIconGreySelected } from '@/assets/img/v2/menu-doc-icon-selected.svg';

import { ReactComponent as SettingIconGrey } from '@/assets/img/v2/menu-settings-icon.svg';
import { ReactComponent as SettingIconSelected } from '@/assets/img/v2/menu-settings-icon-selected.svg';
import { ReactComponent as ContactUsIcon } from '@/assets/img/v2/headphone-icon.svg';

import './MyPetProfile.scss';
import { useGetPet } from '../api/getPet';
import { useTranslation } from 'react-i18next';

export default function MyPetProfiles() {
  const { id } = useParams();
  const { t, i18n } = useTranslation();
  const getPetMutation = useGetPet();
  const navigate = useNavigate();
  const { user } = useAuth();
  const tabs = [
    {
      label: t('Edit Profile'),
      icon: PawIconGrey,
      selectedIcon: PawIconSelected,
      key: 'profile',
    },
    {
      label: t('Vaccination'),
      icon: VaccinationIconGrey,
      selectedIcon: VaccinationIconGreySelected,
      key: 'vaccination',
    },
    {
      label: t('Documents'),
      icon: InsuranceIconGrey,
      selectedIcon: InsuranceIconGreySelected,
      key: 'document',
    },
    {
      label: t('Settings'),
      icon: SettingIconGrey,
      selectedIcon: SettingIconSelected,
      key: 'settings',
    },
  ];
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);
  const [petDetail, setPetDetail] = useState<Pet>();
  useEffect(() => {
    getPetDetail();
  }, []);

  const getPetDetail = async () => {
    const res = await getPetMutation.mutateAsync({
      petId: id ? id : '',
    });
    setPetDetail(res);
  };
  const backToPetList = () => {
    navigate('/my-pet-profiles');
  };
  const onTabChange = (index: number) => {
    setSelectedTabIndex(index);
  };
  return (
    <section className="petsked-container-bg my-pet-detail">
      <BackNav onClick={backToPetList} />
      <div className="pet-detail-top-section">
        <BackNav onClick={backToPetList} hideText={true} />
        <div className="my-pet">
          {petDetail && <PetDetailCard data={petDetail} onChange={() => {}} />}
        </div>
      </div>
      <div className="bottom-pet-details">
        <div className="left-nav">
          <VerticalTabs tabs={tabs} selectedTabIndex={selectedTabIndex} onChange={onTabChange} />
          <div className="contact-us">
            <h5>
              <ContactUsIcon /> {t('Contact US')}
            </h5>
            <p>{t('Reach us for any of pet related queries or for help centre.')}</p>
          </div>
        </div>
        <div className="tab-container">
          {petDetail && id && (
            <>
              {selectedTabIndex == 0 && (
                <PetProfileForm
                  pet={petDetail}
                  isEditMode={true}
                  onSuccess={() => {
                    getPetDetail();
                  }}
                  defaultPetType={user?.defaultPetType}
                />
              )}
              {selectedTabIndex == 1 && <PetVaccinationForm petId={parseInt(id)} />}
              {selectedTabIndex == 2 && <PetInsuranceForm petId={parseInt(id)} />}
              {selectedTabIndex == 3 && <PetSettings petDetail={petDetail} petId={parseInt(id)} />}
            </>
          )}
        </div>
      </div>
    </section>
  );
}
